/** @sfdc-extension-file SFDC_EXT_BRD_LOGIN_SIDEBAR */

/**
 * URL of the Turnstile-protected email-lookup action shipped by this extension.
 * The route file `routes/action.check-email.ts` is auto-discovered, so the path
 * mirrors the flat-file route name.
 */
export const CHECK_EMAIL_ACTION = '/action/check-email';

/**
 * Persists the guest-checkout email on the basket before redirecting to checkout.
 * Route file `routes/action.set-guest-email.ts` is auto-discovered.
 */
export const SET_GUEST_EMAIL_ACTION = '/action/set-guest-email';

/**
 * Loyalty content for the auth decision step. Prefetched from the guest header
 * (mount + hover) and shared with the decision step via a named fetcher — not
 * from `_app`, so the document loader stays unaffected.
 */
export const LOYALTY_CONTENT_RESOURCE = '/resource/loyalty-content';

/** Named fetcher key so header prefetch and AuthDecision share one load. */
export const LOYALTY_CONTENT_FETCHER_KEY = 'loyalty-content';
